var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import ReactSimplyCarousel from "react-simply-carousel";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import { ContainerStyles, DotsNavStyles } from "./subcomponents";
import theme from "../../theme";
var Carousel = function (_a) {
    var children = _a.children, itemsToShow = _a.itemsToShow;
    var _b = useState(0), activeSlide = _b[0], setActiveSlide = _b[1];
    var windowWidth = useWindowSize();
    return (_jsx(ReactSimplyCarousel, __assign({ containerProps: {
            style: __assign(__assign({}, ContainerStyles), { width: windowWidth.isLessThanTablet ? ContainerStyles.width : "57vw" }),
        }, activeSlideIndex: activeSlide, onRequestChange: setActiveSlide, backwardBtnProps: {
            show: false,
        }, forwardBtnProps: {
            show: false,
        }, dotsNav: {
            show: true,
            itemBtnProps: {
                style: __assign(__assign({}, DotsNavStyles), { backgroundColor: theme.lightSilver }),
            },
            activeItemBtnProps: {
                style: __assign(__assign({}, DotsNavStyles), { backgroundColor: theme.cyanBlue }),
            },
        }, itemsToShow: itemsToShow, centerMode: true, preventScrollOnSwipe: true, swipeTreshold: 60 }, { children: children })));
};
export default Carousel;
